import React, { useContext, useEffect, useState } from 'react';
import { Button, TextField, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { TableBaseStyle } from './LoginStyle';
import { AppContext } from '../../../App';

type LoginMailAdressProps = {
  mailAdress: string;
  EntryMailAdress: (userName: string) => void;
  entrymailAdressAction: () => void;
};


const LoginMailAdress: React.FC<LoginMailAdressProps> = (props) => {
  const { t } = useTranslation();
  const classes = TableBaseStyle();

  return (
    <div className={classes.entryContainer}>
      <div className={classes.messageLabel}>{t('LoginMailAdress.メールアドレスが設定されていません', 'メールアドレスが設定されていません')} </div>
      <div className={classes.messageLabel}>{t(`LoginMailAdress.入力したメールアドレスへワンタイムパスワードを送信します`, `入力したメールアドレスへワンタイムパスワードを送信します`)} </div>

      <div style={{ height: '5%' }}></div>
      <div className={classes.entryRow}>
        <TextField
          variant="outlined"
          size="small"
          type="adress"
          className={classes.entry}
          value={props.mailAdress}
          onChange={(e) => props.EntryMailAdress(e.target.value)}
          onKeyPress={(e) => {
            if (e.key == 'Enter') {
              e.preventDefault();
              props.entrymailAdressAction();
            }
          }}
          inputProps={{
            maxLength: 160,	//入力文字数を160より大きくした場合、暗号化したら255文字より大きくなりエラーになる
          }}
        />
      </div>
      <div>
        <>
          <Button className={classes.twoPasswordButton} variant="outlined" onClick={(e) => props.entrymailAdressAction()}>
            {t('LoginMailAdress.送信', '送信')}
          </Button>
        </>
      </div>
    </div>

  );
};
export default LoginMailAdress;